import { colors, darkThemeSelector, styled } from '../../../stitches.config';
import { chassisVars } from './utils';

export const ChassisRear = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'end',
  gap: `$${chassisVars.gap.slot}`,
  padding: `$${chassisVars.padding}`,
  margin: `-$${chassisVars.padding} -$${chassisVars.padding} -$${chassisVars.padding} $${chassisVars.padding}`,
  background: colors.bgSurfaceLight,
  strokeLeft: colors.strokeNeutralLight,
  borderRadius: `0 $${chassisVars.radius} $${chassisVars.radius} 0`,

  [darkThemeSelector]: {
    background: colors.bgSurfaceDark,
    strokeLeft: colors.strokeNeutralDark,
  },

  '*:not(:last-child) > &': {
    strokeLeftRight: colors.strokeNeutralLight,
    borderRadius: 0,

    [darkThemeSelector]: {
      strokeLeftRight: colors.strokeNeutralDark,
    },
  },
});
ChassisRear.displayName = 'ChassisRear';
